var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BASEURL } from '../../components/App/ApplicationConfig';
import { OPERATION, SUBSETTING, } from '../../types/searchTypes';
var WFURL;
(function (WFURL) {
    WFURL["DOWNLOAD"] = "download";
    WFURL["OPENDAP"] = "opendap";
    WFURL["ROOK"] = "rookwps";
})(WFURL || (WFURL = {}));
export const createNotebook = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = `${BASEURL}/notebook`;
    const payload = JSON.stringify({});
    const response = yield fetch(url, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        referrerPolicy: 'no-referrer-when-downgrade',
        body: payload,
    }).then((res) => res.text());
    return response;
});
export const deleteStaleNotebook = (notebookId) => __awaiter(void 0, void 0, void 0, function* () {
    if (notebookId) {
        const url = `${BASEURL}/notebook/${notebookId}`;
        return fetch(url, {
            method: 'DELETE',
            mode: 'cors',
            credentials: 'include',
            referrerPolicy: 'no-referrer-when-downgrade',
        });
    }
    return null;
});
export const checkSnapshotExists = (sessionId) => __awaiter(void 0, void 0, void 0, function* () {
    if (sessionId) {
        const activities = (yield fetch(`${BASEURL}/provenance/session/${sessionId}/activities`, {
            credentials: 'include',
            mode: 'cors',
        }).then((res) => res.status === 200 ? res.json() : undefined));
        if (activities) {
            return activities['@graph'].some((graph) => graph['@type'].indexOf('swirrl:CreateSnapshot') > -1);
        }
    }
    return false;
});
export const deleteStaleSession = (sessionId, hasSnapshot) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `${BASEURL}/session/${sessionId}`;
    if (sessionId && !hasSnapshot) {
        return fetch(url, {
            method: 'DELETE',
            mode: 'cors',
            credentials: 'include',
            referrerPolicy: 'no-referrer-when-downgrade',
        });
    }
    return null;
});
export const runWorkflow = (payload, operation, subsettingMode) => __awaiter(void 0, void 0, void 0, function* () {
    const wfurl = 
    // eslint-disable-next-line no-nested-ternary
    operation === OPERATION.DOWNLOAD
        ? WFURL.DOWNLOAD
        : subsettingMode === SUBSETTING.OPENDAP
            ? WFURL.OPENDAP
            : WFURL.ROOK;
    const url = `${BASEURL}/workflow/${wfurl}/run/`;
    const body = JSON.stringify(payload);
    const response = yield fetch(url, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body,
    }).then((res) => res.status);
    return response;
});
export const getNotebook = (notebookId) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `${BASEURL}/notebook/${notebookId}`;
    const response = yield fetch(url, {
        method: 'GET',
        mode: 'cors',
        credentials: 'include',
        referrerPolicy: 'no-referrer-when-downgrade',
    }).then((res) => res.text());
    return response;
});
